import apiConfig from "../config/apiConfig";
import { toast } from "../utils/toast";
import { apiFetch } from "../apis/apiFetch";


export const queryService = {
  async create(data: any) {
    const res = await apiFetch(apiConfig.getResourceUrl("Query"), {
      method: "POST",
      body: data.params,
    });

    const resJson = await res.json();
    console.log("Query create response:", resJson);
    // if (resJson.errCode === -1) toast.error("Error: " + resJson.message);
    return resJson;
  },

  async getData() {
    const response = await apiFetch(
      `${apiConfig.getResourceUrl("query")}?queryId=GET_ALL`,
      {
        method: "GET",
      }
    );

    if (!response.ok) {
      throw new Error("Error: " + response.status);
    }

    const data = await response.json();
    return data.resource || [];
  },

  async getByFilter(queryIdParam: string, args: string) {
    const response = await apiFetch(
      `${apiConfig.getResourceUrl("query")}?queryId=${queryIdParam}&args=${args}`,
      {
        method: "GET",
      }
    );

    if (!response.ok) {
      throw new Error("Error: " + response.status);
    }

    const data = await response.json();
    return data.resource || [];
  },

  async update(id: string, base64Resource: string) {
    const formData = new FormData();
    formData.append("resource", base64Resource);

    const response = await apiFetch(
      `${apiConfig.getResourceUrl("query")}?queryId=MODIFY`,
      {
        method: "POST",
        body: formData,
      }
    );

    const resJson = await response.json();
    console.log("Query update response:", resJson);
    if (resJson.errCode === -1) toast.error("Error: " + resJson.message);
    return resJson;
  },
};
